<div
  *ngIf="opportunitiesWithStage$ | async as oppsWithStage"
  class="column-contents"
  (cdkDropListDropped)="drop($event)"
  [cdkDropListData]="oppsWithStage"
  cdkDropList
  (scroll)="getNextPage($event)"
>
  <ng-container class="opportunity-card-view" *ngFor="let opportunity of oppsWithStage.opportunities">
    <div
      class="opportunity-card-view"
      cdkDrag
      [cdkDragDisabled]="store.updateOpportunityWorkState.isLoading$(opportunity.opportunityId) | async"
    >
      <sales-ui-pipeline-card
        [opportunity]="opportunity"
        (selectedOpportunityId)="handleOpportunitySelected(opportunity)"
      ></sales-ui-pipeline-card>
      <div class="custom-card-placeholder" *cdkDragPlaceholder></div>
    </div>
  </ng-container>
  <div *ngIf="this.state.isLoading$ | async">
    <mat-spinner class="loading-spinner" [diameter]="16"></mat-spinner>
  </div>
</div>
